import { render, staticRenderFns } from "./LaporanTagihanPerKapal.vue?vue&type=template&id=e127e3d6&scoped=true&"
import script from "./LaporanTagihanPerKapal.vue?vue&type=script&lang=js&"
export * from "./LaporanTagihanPerKapal.vue?vue&type=script&lang=js&"
import style0 from "./LaporanTagihanPerKapal.vue?vue&type=style&index=0&id=e127e3d6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e127e3d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VTextField})
